import api from './api';
import { API_ENDPOINTS } from '../constants';
import { VehicleCapture, VehicleCaptureFilters, VehicleCaptureResponse } from '../types';

const vehicleCaptureService = {
  /**
   * Get vehicle captures with filters
   */
  getVehicleCaptures: async (filters: VehicleCaptureFilters = {}): Promise<VehicleCaptureResponse> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: VehicleCaptureResponse;
    }>(API_ENDPOINTS.VEHICLE_CAPTURES.LIST, {
      params: filters,
    });
    return response.data.data;
  },

  /**
   * Get vehicle capture by ID
   */
  getVehicleCaptureById: async (id: string): Promise<VehicleCapture> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: VehicleCapture;
    }>(API_ENDPOINTS.VEHICLE_CAPTURES.GET_BY_ID(id));
    return response.data.data;
  },

  /**
   * Delete vehicle capture
   */
  deleteVehicleCapture: async (id: string): Promise<void> => {
    await api.delete(API_ENDPOINTS.VEHICLE_CAPTURES.DELETE(id));
  },
};

export default vehicleCaptureService;

